/**
 * The ?stack= / ?sub= pair Comp keeps in its URL (the rail carries it to
 * Compare and JD·Skills and back).
 *
 * Both params are built together and written in ONE setSearchParams call.
 * FIXED 2026-09-25: they used to be written by two back-to-back calls, and
 * the second one's functional update read the URL from before the first -
 * putting the OLD vertical back (Comp showed Finance, the URL still said
 * Data Analytics, so Compare opened on Data Analytics).
 *
 * id / subId 0 or null mean "none" (0 is the synthetic "All" option), so
 * the param comes off entirely rather than becoming ?stack=0.
 */
export function stackSearchParams(id, subId = null) {
  const next = {};
  if (id) next.stack = String(id);
  if (subId) next.sub = String(subId);
  return next;
}

export function readStackSelection(searchParams, sharedSelection = null) {
  if (sharedSelection != null) return sharedSelection;
  const readId = (key) => {
    const value = searchParams.get(key);
    const id = value && /^\d+$/.test(value) ? Number(value) : null;
    return Number.isSafeInteger(id) && id > 0 ? id : null;
  };
  return { verticalStackId: readId("stack"), subStackId: readId("sub") };
}
